<div id="state-of-car-informations" uk-modal>
    <div class="uk-modal-dialog wrap wrap-width">
        <a class="uk-modal-close-default">
            <img src="../../../../assets/icons/Close.svg" height="32px" width="32px">
        </a>
        <div *ngIf="loading === false" class="uk-modal-body">
            <div class="uk-display-inline-block research-form-controls uk-width-1-1 uk-margin-remove">
                <h2 class="main-title bold color-grey uk-text-uppercase uk-margin-small-bottom">
                    État des lieux
                </h2>
                <a href="#" [routerLink]="['/ressource/vehicle/informations/' + state.idVehicle ]" style="width: max-content;"
                class="main-title regular color-cold-grey links uk-display-block pointer uk-modal-close uk-margin-bottom">
                    {{ state.vehicle.name }}
                    <div class="uk-display-inline-block" *ngIf="relatedStates.length === 0">
                        <span *ngIf="state.part === 1">(Avant)</span>
                        <span *ngIf="state.part === 2">(Arrière)</span>
                        <span *ngIf="state.part === 3">(Aile gauche)</span>
                        <span *ngIf="state.part === 4">(Aile droite)</span>
                    </div>
                </a>
                <div uk-grid class="uk-grid-small">
                    <a href="#" class="uk-margin-small-bottom uk-margin-small-top uk-display-inline-block pointer uk-modal-close"
                    [routerLink]="['/user/informations/' + state.societyVopUser.AccountId ]"
                    *ngIf="state.societyVopUser.FirstName.length !== 0 && state.societyVopUser.LastName.length !== 0">
                        <img src="../../../../assets/icons/User.svg" width="40px" height="40px" class="vertical-align-middle">
                        <span class="vertical-align-middle color-dark-turquoise bold uk-text-uppercase">
                            {{ state.societyVopUser.FirstName }} {{ state.societyVopUser.LastName }}
                        </span>
                    </a>
                    <div class="uk-margin-small-bottom uk-margin-small-top uk-display-inline-block"
                    *ngIf="state.ISOCreated.length !== 0">
                        <img src="../../../../assets/icons/Booking.svg" width="40px" height="40px">
                        <span class="vertical-align-middle color-cold-grey regular uk-text-uppercase">
                            Déclaré le <span humanDateFormat="{{ state.ISOCreated }}" shortened="true" class="bold"></span> à {{state.ISOCreated | date:'HH:mm'}}
                        </span>
                    </div>
                    <a href="#" class="uk-margin-small-bottom uk-margin-small-top uk-display-inline-block pointer uk-modal-close"
                    *ngIf="state.idBooking > 0"
                    [routerLink]="['/reservation/informations/' + state.idBooking ]">
                        <img src="../../../../assets/icons/Booking.svg" width="40px" height="40px">
                        <span class="vertical-align-middle color-dark-turquoise bold uk-text-uppercase">
                            Réservation #{{ state.idBooking }}
                        </span>
                    </a>
                </div>
                <div uk-grid style="min-height: 500px; margin-top: 0px;">
                    <div *ngIf="relatedStates.length === 0" class="uk-width-8-12">
                        <div class="img-wrap" uk-lightbox>
                            <a class="uk-button uk-button-default" [href]="state.imgs[0]">
                                <img [src]="state.imgs[0]" onerror="this.src='../../../../assets/img/no-photo.png';this.className='img-error';">
                            </a>
                        </div>
                    </div>
                    <div *ngIf="relatedStates.length > 0" class="uk-width-8-12 uk-grid-small" uk-grid>
                        <div *ngFor="let state of states; let i = index" class="uk-width-6-12">
                            <div class="img-wrap" uk-lightbox>
                                <a class="uk-button uk-button-default" [href]="state.imgs[0]">
                                    <span *ngIf="state.part === 1" class="tag bold">Avant</span>
                                    <span *ngIf="state.part === 2" class="tag bold">Arrière</span>
                                    <span *ngIf="state.part === 3" class="tag bold">Gauche</span>
                                    <span *ngIf="state.part === 4" class="tag bold">Droite</span>
                                    <img [src]="state.imgs[0]" onerror="this.src='../../../../assets/img/no-photo.png';this.className='img-error';">
                                </a>
                            </div>
                        </div>
                    </div>
                    <div class="uk-width-4-12">
                        <div class="uk-form-stacked">
                            <div class="uk-margin">
                                <label class="label">Commentaire</label>
                                <div class="uk-form-controls uk-margin-small-top" >
                                    <span class="color-cold-grey bold" *ngIf="state.comment.length === 0">Aucun commentaire renseigné.</span>
                                    <span class="color-cold-grey bold">{{ state.comment }}</span>
                                </div>
                            </div>
                            <div class="uk-margin">
                                <label class="label">Statut</label>
                                <div class="uk-form-controls uk-margin-small-top">
                                    <select class="combo-list alt color-cold-grey bold" [(ngModel)]="status" style="width: 250px;">
                                        <option value="0">Nouveau</option>
                                        <option value="1">À traiter</option>
                                        <option value="2">Archivé</option>
                                    </select>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="uk-modal-footer">
            <p class="uk-text-right">
                <button class="button bold uk-modal-close" type="button">Annuler</button>
                <button class="button bold uk-margin-small-left" type="submit" (click)="updateStatus()">
                    Sauvegarder
                </button>
            </p>
        </div>
    </div>
</div>